/**
 * @desc 新增批次
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.BatchMasterCreateRequestParamDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/fulfilment/createBatchNo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
